import { useCallback, useEffect } from "react";
import { observer } from "mobx-react-lite";

import { Loader, Modal } from "../../shared";
import { Link } from "react-router-dom";
import { T } from "../../../../constants";
import { env } from "../../../../environment";
import { JackpotTypes } from "../../../../enums/jackpot";
import { JackpotDetails } from "../../../../models/modal";
import { useStore, useTranslation } from "../../../../hooks";
import TicketState from "../check-ticket-modal/ticket-result-header/ticket-state";
import TicketResultKeyValue from "../check-ticket-modal/ticket-result-header/ticket-result-key-value";

interface JackpotModalProps {}

export const JackpotModal: React.FC<JackpotModalProps> = observer(() => {
  const t = useTranslation();

  const {
    jackpotStore,
    partnerStore: { businessUnitId, betshopId },
    ticketsStore,
    modalStore: {
      setJackpotModal,
      jackpotModal: { data: jackpotRowData },
    },
  } = useStore();

  const {
    jackpotDetails: { isLoading, data },
  } = jackpotStore;

  useEffect(() => {
    if (jackpotRowData.id) {
      jackpotStore.getJackpotDetails(jackpotRowData.id, jackpotRowData.level);
    }
  }, [jackpotRowData]);

  useEffect(() => {
    return () => {
      ticketsStore.resetTicketData();
      jackpotStore.resetJackpotDetails();
    };
  }, []);

  const handleClose = useCallback(() => {
    setJackpotModal({ open: false, data: {} as JackpotDetails });
  }, []);

  if (isLoading) return <Loader />;

  return (
    <Modal title={T.JACKPOT_INFO} onClose={handleClose}>
      <div className="wrapper-pp">
        <TicketState className="state-jackpot">
          <TicketResultKeyValue
            label={T.LEVEL}
            value={JackpotTypes[data.level]}
          />
          <TicketResultKeyValue label={T.ID} value={data.id} />
          <TicketResultKeyValue
            label={T.CURRENT_POT}
            value={`${data.currencyCode} ${data.currentPot?.toFixed(2)}`}
          />
          <TicketResultKeyValue label={T.NAME} value={data.name} />
        </TicketState>
        {data.values ? (
          <div className="date-space">
            <div className="date-block">
              <div className="date-title">
                <span>
                  {t(
                    data.level === JackpotTypes.Betshop
                      ? T.GAME_LIST
                      : T.BETSHOP_LIST,
                  )}
                </span>
              </div>
              <p className="date-info">{data.values.join(", ")}</p>
            </div>
          </div>
        ) : null}
      </div>
      {data.level !== JackpotTypes.Game ? (
        <div className="bet-button-block">
          <a
            href={`${env.multiStreamDomain}/?jackpotLevel=${data.level}&businessUnitId=${businessUnitId}&betshopId=${betshopId}`}
            className="pp-button active"
            target="_blank"
          >
            {t(T.SHOW_JACKPOT)}
          </a>
        </div>
      ) : null}
    </Modal>
  );
});
